import {tableBorderGray} from 'mui/mixins/legacy-colors-mixin';

const normal = '0.1rem';

export default {
    basic: {
        // deprecated, not enough contrast against white
        border: `${normal} solid ${tableBorderGray}`,
    },
    basicRight: {
        borderRight: `${normal} solid ${tableBorderGray}`,
    },
    basicLeft: {
        borderLeft: `${normal} solid ${tableBorderGray}`,
    },
    basicBottom: {
        borderBottom: `${normal} solid ${tableBorderGray}`,
    },
    basicTop: {
        borderTop: `${normal} solid ${tableBorderGray}`,
    },
};
